import { Component, Injector } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { Firearm, FIREARM_TYPE, FirearmRevision } from 'assets-model';
import { AssetService, FirearmService, RefCodeStorage } from 'assets-service';
import { ASSET_AUDIT_LIST_COLUMNS, auditCellClass, previousRevisionGetterBuilder } from '../../asset/audit/asset-audit-list.component';
import { ASSET_SEARCH_ALL_ASPECT_COLUMNS, ASSET_SEARCH_ELECTRICAL_ASPECT_COLUMNS, ASSET_SEARCH_MAINTENANCE_ASPECT_COLUMNS, ASSET_SEARCH_MECHANICAL_ASPECT_COLUMNS, ASSET_SEARCH_RESULT_DATA_COLUMNS } from '../../asset/search/asset-search.component';
import { FIREARM_SEARCH_BASIC_COLUMNS, FIREARM_SEARCH_RESULT_DEFAULT_DISPLAYED_COLUMNS, FirearmSearchComponent } from '../search/firearm-search.component';

export const FIREARM_AUDIT_LIST_COLUMNS = ['revisionDate', 'revisionUsername', ...ASSET_SEARCH_RESULT_DATA_COLUMNS, 'tags', ...FIREARM_SEARCH_BASIC_COLUMNS, ...ASSET_SEARCH_ALL_ASPECT_COLUMNS];

@Component({
  selector: 'app-firearm-audit-list',
  templateUrl: './firearm-audit-list.component.html',
  styleUrls: ['./firearm-audit-list.component.scss']
})
export class FirearmAuditListComponent extends FirearmSearchComponent {

  auditDataSource: FirearmRevision[] = [];
  _item: Firearm;

  displayedColumns: string[] = [...FIREARM_AUDIT_LIST_COLUMNS];
  disabledColumns: string[] = ['assetId'];

  get auditAssetId() {
    return this.routeParams?.assetId;
  }

  get item() {
    if (this._item != null) {
      return this._item;
    } else if (this.auditDataSource != null) {
      return this.auditDataSource[0];
    } else return null;
  }

  get hasHadMechanicalAspect() {
    for (let revision of this.auditDataSource) {
      if (revision.asset?.mechanicalAspect != null) {
        return true;
      }
    }
    return false;
  }

  get hasHadElectricalAspect() {
    for (let revision of this.auditDataSource) {
      if (revision.asset?.electricalAspect != null) {
        return true;
      }
    }
    return false;
  }

  get hasHadMaintenanceAspect() {
    for (let revision of this.auditDataSource) {
      if (revision?.asset?.maintenanceAspect != null) {
        return true;
      }
    }
    return false;
  }

  get editorTitle(): string {
    var title = "Firearm Asset Audit History";
    if (this.item) {
      title = title.replace('Firearm Asset', FIREARM_TYPE.typeName(this.item));
    }
    return title;
  }

  assetGetter = (element: Firearm): any => {
    return element?.entity?.asset;
  }

  maintenanceAspectGetter = (element: Firearm): any => {
    return this.assetGetter(element).maintenanceAspect;
  }

  electricalAspectGetter = (element: Firearm): any => {
    return this.assetGetter(element).electricalAspect;
  }

  mechanicalAspectGetter = (element: Firearm): any => {
    return this.assetGetter(element).mechanicalAspect;
  }

  firearmPreviousRevisionGetter = previousRevisionGetterBuilder(() => this.auditDataSource);

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected firearmService: FirearmService,
    protected assetService: AssetService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, firearmService, assetService, refCodeStorage, fb, formStorage, injector);
    this.autoSearch = false;

  }

  protected onInitAsyncComplete(): void {
    super.onInitAsyncComplete();
    this.firearmService.get(this.auditAssetId).subscribe(
      data => this._item = data
    )
  }

  disableUnusedAspectColumns() {
    this.columns.setColumnsEnabled(ASSET_SEARCH_MECHANICAL_ASPECT_COLUMNS, this.hasHadMechanicalAspect);
    this.columns.setColumnsEnabled(ASSET_SEARCH_ELECTRICAL_ASPECT_COLUMNS, this.hasHadElectricalAspect);
    this.columns.setColumnsEnabled(ASSET_SEARCH_MAINTENANCE_ASPECT_COLUMNS, this.hasHadMaintenanceAspect);
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.sort.disabled = true;
  }

  backRoute(): any[] {
    return [...FIREARM_TYPE.editRouteBase, this.auditAssetId];
  }

  loadPage() {
    this.firearmService.findAuditHistory(this.auditAssetId).subscribe(
      data => {
        this.auditDataSource = (<FirearmRevision[]>data)
        this.disableUnusedAspectColumns();
      }
    )
  }

  //disable actual search functionality
  createServiceArguments() {
    return {}
  }

  cellClass(element: FirearmRevision, fieldName: string, relationshipGetter?: (e: FirearmRevision) => any, previousRevisionGetter?: (e: FirearmRevision) => FirearmRevision): any {
    return auditCellClass(relationshipGetter, previousRevisionGetter)(element, fieldName);
  }

}